import { Button } from "@material-tailwind/react";
import { ReactNode } from "react";
import DefaultLoading from "../DefaultLoading";

const ClickBaseButton = ({
  children,
  onClick,
  className,
  isLoading,
}: {
  children: ReactNode;
  onClick: () => void;
  className?: string;
  isLoading?: boolean;
}) =>
  isLoading ? (
    <DefaultLoading className={className}/>
  ) : (
    <Button
    placeholder={undefined}
      onClick={() => onClick()}
      className={`mt-5 bg-primary normal-case ${className}`}
      fullWidth
      type="submit"
    >
      {children}
    </Button>
  );

export default ClickBaseButton;
